import React from 'react';
import type {CheckoutBrandModel} from '../../../domain/models/common/CheckoutBrand.model';
import {hexToRgbString} from '../../../domain/utils/colors';

export function getBrandStyle(checkoutBrand?: CheckoutBrandModel): React.CSSProperties {
  const buttonColor = hexToRgbString(checkoutBrand?.global?.buttonColor);
  const placeOrderButtonColor = hexToRgbString(checkoutBrand?.global?.placeOrderButtonColor);
  const formBackgroundColor = hexToRgbString(checkoutBrand?.formSection?.backgroundColor);
  const summaryBackgroundColor = hexToRgbString(checkoutBrand?.summarySection?.backgroundColor);
  const buttonTextColor = hexToRgbString(checkoutBrand?.global?.buttonTextColor);
  const placeOrderButtonTextColor = hexToRgbString(checkoutBrand?.global?.placeOrderButtonTextColor);
  const formTextColor = hexToRgbString(checkoutBrand?.formSection?.textColor);
  const summaryTextColor = hexToRgbString(checkoutBrand?.summarySection?.textColor);
  const footerBackgroundColor = hexToRgbString(checkoutBrand?.footer?.backgroundColor);
  const footerTextColor = hexToRgbString(checkoutBrand?.footer?.textColor);
  const cornerRadius = checkoutBrand?.global?.cornerRadius;
  const hasCornerRadius = typeof cornerRadius === 'number';

  return {
    ...(buttonColor && {'--checkoutButtonColor': buttonColor}),
    ...(placeOrderButtonColor && {'--checkoutPlaceOrderButtonColor': placeOrderButtonColor}),
    ...(formBackgroundColor && {'--checkoutFormBackgroundColor': formBackgroundColor}),
    ...(summaryBackgroundColor && {'--checkoutSummaryBackgroundColor': summaryBackgroundColor}),
    ...(buttonTextColor && {'--checkoutButtonTextColor': buttonTextColor}),
    ...(placeOrderButtonTextColor && {'--checkoutPlaceOrderButtonTextColor': placeOrderButtonTextColor}),
    ...(formTextColor && {'--checkoutFormTextColor': formTextColor}),
    ...(summaryTextColor && {'--checkoutSummaryTextColor': summaryTextColor}),
    ...(footerBackgroundColor && {'--checkoutFooterBackgroundColor': footerBackgroundColor}),
    ...(footerTextColor && {'--checkoutFooterTextColor': footerTextColor}),
    ...(hasCornerRadius && {'--checkoutCornerRadius': `${cornerRadius}`}),
    ...(hasCornerRadius && {'--payments-co-border-radius': `${cornerRadius}`}),
  } as React.CSSProperties;
}
